import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuList, styled } from 'netline-ui';
import { NavigationArea } from 'types';

import { usePreferencesMenuItems } from '../../Navigation';

import MobileHeader from './MobileHeader/MobileHeader';
import styles, { mobilePreferencesClasses } from './MobilePreferences.styles';

const MobilePreferencesRoot = styled('div', { name: mobilePreferencesClasses.$name })(styles);

type MobilePreferencesProps = {
  open: boolean;
  onClose: () => void;
};

export type PreferencesMenuClose = {
  onMenuClose?: () => void;
};

const MobilePreferences = ({ open, onClose }: MobilePreferencesProps) => {
  const { t } = useTranslation();

  const closeMenu = useCallback(() => {
    onClose();
  }, [onClose]);

  const onMenuClick = useCallback(() => {}, []);

  const wrappedItems = usePreferencesMenuItems(NavigationArea.Mobile, onMenuClick, closeMenu);
  if (!open) {
    return null;
  }

  return (
    <MobilePreferencesRoot className={mobilePreferencesClasses.root} data-testid="MobilePreferences-root">
      <MobileHeader title={t('mobileNavigation.preferences')} onClose={onClose} />
      <section className={mobilePreferencesClasses.paper}>
        <MenuList>{wrappedItems}</MenuList>
      </section>
    </MobilePreferencesRoot>
  );
};

export default MobilePreferences;
